import { IsNotEmpty, IsUUID } from 'class-validator';

export class TradeOfferEditDTO {

    @IsNotEmpty()
    @IsUUID()
    tradeRequestId: string;

    @IsNotEmpty()
    @IsUUID()
    eventId: string;

}
